"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _table = require("../table");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      border-right: 1.4px solid ", ";\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      &:hover {\n        border-right: 1.4px solid ", ";\n      }\n      &:active {\n        border-right: 1.4px dotted ", ";\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 5px;\n  right: 0;\n  ", ";\n  cursor: ew-resize;\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    top: 0;\n    bottom: 0;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      top: 5px;\n      bottom: 5px;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getPosition = function getPosition(props) {
  if (props.height === 'small') {
    return (0, _styledComponents.css)(_templateObject());
  }

  return (0, _styledComponents.css)(_templateObject2());
};

var StyledGrip = _styledComponents["default"].div(_templateObject3(), function (props) {
  return getPosition(props);
}, function (props) {
  if (!props.separator) {
    return (0, _styledComponents.css)(_templateObject4(), function (props) {
      return (0, _table.getColors)(props).resizingBorder;
    }, function (props) {
      return (0, _table.getColors)(props).resizingBorder;
    });
  }

  return (0, _styledComponents.css)(_templateObject5(), function (props) {
    return (0, _table.getColors)(props).resizingBorder;
  });
});

var _default = StyledGrip;
exports["default"] = _default;